/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, useContext } from "react";
import "../css/dropZone.css";
import axios from "axios";
import { openDB } from "idb";
import { XIcon } from "@heroicons/react/solid";
import * as XLSX from "xlsx";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Context from "../context/context"
import { v4 as uuidv4 } from "uuid";
const DropZone = ({ close, setIsBulkUploadOpen }) => {
  const fileInputRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [validFiles, setValidFiles] = useState([]);
  const [menus, setMenus] = useState([]);
  const [unsupportedFiles, setUnsupportedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [showResults, setShowResults] = useState(true);
  const [itemMenu, setItemMenu] = useState("");
  const [loading, setLoading] = useState(false)
  const context = useContext(Context)
  const { getBulkData, bulkUploadedData, setBulkUploadedData} = context
  useEffect(() => {
    if (Object.keys(bulkUploadedData).length) {
      setLoading(true)

      setTimeout(() => setLoading(false), 2000)

      setShowResults(false);
    }
  }, [])
  useEffect(() => {
    let filteredArr = selectedFiles.reduce((acc, current) => {
      const x = acc.find((item) => item.name === current.name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    setValidFiles([...filteredArr]);
  }, [selectedFiles]);

  useEffect(() => {
    const handle = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = await db.transaction("menu", "readonly").objectStore("menu");
      const currentMenues = await tx.getAll();
      setMenus(currentMenues);
      // setItemMenu(currentMenues.length ? currentMenues[0]?.menu_uuid : "")
    }
    handle();
  }, []);

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const dragOver = (e) => {
    preventDefault(e);
  };

  const dragEnter = (e) => {
    preventDefault(e);
  };

  const dragLeave = (e) => {
    preventDefault(e);
  };

  const fileDrop = (e) => {
    preventDefault(e);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  const filesSelected = () => {
    if (!selectedFiles.length) {
      if (fileInputRef.current.files.length) {
        handleFiles(fileInputRef.current.files);
      }
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleFiles = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (validateFile(files[i])) {
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
      } else {
        files[i]["invalid"] = true;
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
        setErrorMessage("File type not permitted");
        setUnsupportedFiles((prevArray) => [...prevArray, files[i]]);
      }
    }
  };

  const validateFile = (file) => {
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }

    return true;
  };

  const fileSize = (size) => {
    if (size === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const fileType = (fileName) => {
    return (
      fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) ||
      fileName
    );
  };

  const removeFile = (name) => {
    const index = validFiles.findIndex((e) => e.name === name);
    const index2 = selectedFiles.findIndex((e) => e.name === name);
    const index3 = unsupportedFiles.findIndex((e) => e.name === name);
    validFiles.splice(index, 1);
    selectedFiles.splice(index2, 1);
    setValidFiles([...validFiles]);
    setSelectedFiles([...selectedFiles]);
    if (index3 !== -1) {
      unsupportedFiles.splice(index3, 1);
      setUnsupportedFiles([...unsupportedFiles]);
    }
  };


  const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }

      result.push(obj);
    }

    //return result; //JavaScript object
    return JSON.stringify(result); //JSON
  }
  const uploadFiles = async () => {
    setLoading(true)
    for (let i = 0; i < validFiles.length; i++) {
      let file = ""
      var f = validFiles[i];
      const reader = new FileReader();

      reader.onload = (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        /* Update state */
        // console.log("Data>>>" + data);// shows that excel data is read
        file = convertToJson(data); // shows data in json format
        // console.log((file))
        file = JSON.parse(file)
        file = file.map(a => ({ ...a, key: uuidv4() }))


        setTimeout(() => getBulkData({ file, outlet_uuid: localStorage.getItem("outlet_uuid"), menu: itemMenu }, {
          count: file.length,
          total: file.length,
          newItems: 0,
          newCategoryCount: 0,
          updateCount: 0,
        }), 2000)

        setTimeout(close, 3000)



      };
      reader.readAsBinaryString(f);


      // const formData = new FormData();
      // formData.append("files", file);
      // formData.append("outlet_uuid", localStorage.getItem("outlet_uuid"));
      // formData.append("menu", itemMenu);

      //https://api.myfooddo.com/item/postBulkItem

      // axios
      //   .post("https://api.myfooddo.com/item/postBulkItem", formData, {
      //     headers: {
      //       Authorization: "Bearer " + localStorage.getItem("token"),
      //     },
      //   })
      //   .then((response) => {
      //     console.log(response)
      //     if (response?.data?.success) {
      //  setTimeout(() => getBulkData(response.data.key), 3000)


      //     }
      //     // close()
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     setLoading(false)
      //   });
    }
  };

  // const setItemMenu = (e) => {
  //   if (e.target.checked === true) {
  //     itemMenu.push(e.target.value);
  //   } else {
  //     const index = itemMenu.indexOf(e.target.value);
  //     if (index > -1) {
  //       itemMenu.splice(index, 1);
  //     }
  //   }
  // };
  const updateData = async () => {
    setLoading(true)
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = await db.transaction("outlet", "readonly").objectStore("outlet");
    let outlet = await tx.getAll();
    let response = await axios({
      url: "https://api.myfooddo.com/item/getBulkItem",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: { outlet_uuid: outlet[0].outlet_uuid, brand_uuid: outlet[0].brand_uuid.filter(a => a) },
    })
    console.log("response", response)
    let data = response.data.result
    tx = await db.transaction("menu", "readwrite").objectStore("menu");
    await tx.clear()
    for (let a of data.MenusData) {
      await tx.put({ IDENTIFIER: a.menu_uuid, ...a })
    }


    tx = await db.transaction("category", "readwrite").objectStore("category");
    await tx.clear()

    for (let a of data.CategoryData) {
      await tx.put({ IDENTIFIER: a.category_uuid, ...a })
    }


    tx = await db.transaction("item", "readwrite").objectStore("item");
    await tx.clear()

    for (let a of data.ItemsData) {
      await tx.put({ IDENTIFIER: a.item_uuid, ...a })
    }
    setLoading(false)
    setBulkUploadedData({})
    close()
  }
  // console.log(menus);

  return (
    <div className="newCategory" draggable={false}>
      <div className="newCatContainer">
        <div className="newCatContainer_header">
          <h2>Upload Items Excel File</h2>
          <XIcon className="closeicon" onClick={() => setIsBulkUploadOpen(false)} />
        </div>

        <div className="newCatContainer2">
          {showResults ? <><div className="drop-container"
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            onClick={fileInputClicked}
          >
            <div className="drop-message">
              <div className="upload-icon"></div>
              Drag & Drop files here or click to select file(s)
            </div>
            <input
              ref={fileInputRef}
              className="file-input"
              type="file"
              multiple
              onChange={filesSelected}
            />
          </div>

            {validFiles.map((data, i) => (
              <div className="file-status-bar" key={i}>
                <div className="file-icon-container">
                  <div className="file-type">{fileType(data.name)}</div>
                  <InsertDriveFileOutlinedIcon sx={{ fontSize: 40 }} />
                </div>
                <div>
                  <span className=''  >
                    <p className="file-size">{data.name}({fileSize(data.size)})</p>
                    {data.invalid && (
                      <p className="file-error-message">({errorMessage})</p>
                    )}
                  </span>
                </div>
                <div className="error" onClick={() => removeFile(data.name)} > X </div>
              </div>
            ))}

            <div className="itemMenu">
              <p>Select Menu</p>
              <select
                id="menu_select"
                value={itemMenu}
                onChange={(e) => setItemMenu(e.target.value)}
              >
                <option value="">None</option>
                {menus.filter(a => !a.meal_uuid)?.map((menu, i) => (
                  <option key={i} value={menu.menu_uuid}>
                    {menu.menu_title}
                  </option>
                ))}
              </select>
            </div>

            {unsupportedFiles.length === 0 && validFiles.length ? (
              loading ?
                <button className="file-upload-btn" > <svg viewBox="0 0 100 100" style={{ color: "white", width: "25px" }} >
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
                </button> : <button className="file-upload-btn" onClick={() => uploadFiles()} >Upload </button>
            ) : (
              ""
            )}
            {unsupportedFiles.length ? (
              <p className='file-error-message'>Please remove all unsupported files.</p>
            ) : (
              ""
            )}</> :
            < > <div>

              <ol className="success" id="message" style={{ color: "black" }}></ol>
              {bulkUploadedData ? <ul className="success" id="message" style={{ color: "black" }}>

                <li><b>1.</b> <b style={{ color: "green" }}>{bulkUploadedData.newCategoryCount}</b> New <b style={{ color: "green" }}>Categories Created</b> Successfully</li>
                <li><b>2.</b> <b style={{ color: "green" }}>{bulkUploadedData.newItems}</b> New <b style={{ color: "green" }}>Items Created</b> Successfully</li>
                <li><b>3.</b> <b style={{ color: "green" }}>{bulkUploadedData.updateCount} Items Updated</b> Successfully</li>
              </ul> : ""}
            </div>
              {loading ?
                <button className="file-upload-btn" > <svg viewBox="0 0 100 100" style={{ color: "white", width: "25px" }} >
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
                </button> :
                <button className="file-upload-btn" onClick={() => updateData()} > Okay </button>
              }
            </>}

        </div>
      </div>
    </div>
  );
};
export default DropZone;
